import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data.user);
                // Clear hash so subsequent renders don't re-trigger
                window.history.replaceState(null, "", window.location.pathname);
                toast.success(`Welcome, ${data.user.name || "friend"}!`);
                navigate("/app", { replace: true, state: { user: data.user } });
            } catch (e) {
                console.error(e);
                toast.error("Sign-in failed. Please try again.");
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center">
                <div className="font-heading text-2xl mb-2">Signing you in…</div>
                <div className="text-muted-foreground">A warm welcome is on the way.</div>
            </div>
        </div>
    );
}
